import React from 'react';

const ReloadIcon = ({className}) => (
  <svg className={className} viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.5 17.5C13.7569 17.5 16.4062 14.9768 16.4062 11.875C16.4062 8.7732 13.7569 6.25 10.5 6.25V10L3.9375 5L10.5 0V3.75C15.204 3.75 19.0312 7.39504 19.0312 11.875C19.0312 16.355 15.204 20 10.5 20C5.79604 20 1.96875 16.355 1.96875 11.875H4.59375C4.59375 14.9768 7.24311 17.5 10.5 17.5Z" fill="#00D9CD"/>
  </svg>
);

export default ReloadIcon;
